var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "#26262C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1594_2099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5223 4.71747C13.7345 4.47501 13.7099 4.10649 13.4675 3.89434C13.225 3.68219 12.8565 3.70676 12.6443 3.94922L9.66307 7.35635L7.13334 3.98334C7.02317 3.83646 6.85028 3.75 6.66667 3.75H4.33333C4.11238 3.75 3.9104 3.87485 3.81159 4.07247C3.71278 4.27009 3.7341 4.50658 3.86667 4.68334L7.62143 9.68968L4.47766 13.2825C4.26551 13.525 4.29008 13.8935 4.53254 14.1057C4.77499 14.3178 5.14352 14.2933 5.35567 14.0508L8.33692 10.6437L10.8667 14.0167C10.9769 14.1636 11.1497 14.25 11.3333 14.25H13.6667C13.8876 14.25 14.0896 14.1252 14.1884 13.9275C14.2872 13.7299 14.2659 13.4934 14.1333 13.3167L10.3786 8.31033L13.5223 4.71747Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1594_2099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d995f3311308becd153a2f2d8ef708e7.svg";
export { ForwardRef as ReactComponent };